export interface SetRoutingDestinationInput {
    containerId: string;
    warehouseId: string;
    routingDestinationName: string;
    associate: string;
    locale?: string;
}

export interface SetRoutingDestinationOutput {
}

export const buildSetRoutingDestinationInput = (containerId: string, warehouseId: string, routingDestinationName: string, associate: string, locale: string): SetRoutingDestinationInput => {
    return {
        containerId,
        warehouseId,
        routingDestinationName,
        associate,
        locale
    }
}
